import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo } from 'react'
import { SearchContext } from '../../../../contexts/SearchContext'
import ReactSelect from '../../../FormComponents/ReactSelect'

export default observer(function OrderSelect() {
  const { search } = useContext(SearchContext)

  const orderOptions = useMemo(() => {
    const defaultOptions = [
      { label: 'Reach', value: 'reach' },
      { label: 'Engagement Rate', value: 'engagement_rate' }
    ]
    if(search.username) defaultOptions.push({ label: 'Best match', value: 'username' })
    if(search.audience_countries?.length) defaultOptions.push({ label: 'Audience Countries %', value: 'audience_countries' })
    if(search.audience_cities.length) defaultOptions.push({ label: 'Audience Cities %', value: 'audience_cities' })
    if(search.audience_age_groups.length) defaultOptions.push({ label: 'Audience Age Groups %', value: 'audience_age_groups' })
    return defaultOptions
  }, [
    search.audience_countries,
    search.audience_cities,
    search.audience_age_groups,
    search.username,
  ])

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-rb-mat-grey dark:text-gray-400">Sort by</span>
      <div className="w-56">
        <ReactSelect
          name="order"
          onChange={({ value }) => search.order = value}
          value={search.order}
          options={orderOptions}
          isSearchable={false}
        />
      </div>
    </div>
  )
})